module.exports = __webpack_public_path__ + "static/media/material-gold.040a787a.svg";